import React from "react";

export default function Projects() {
	return (
		<section id="projects">
			<div className="section-header">Projects (Selected)</div>
			<p>
				Coming soon — highlight microservices with RabbitMQ/Redis, Angular NX
				monorepo with Module Federation, and a gRPC discount pricing service.
			</p>
		</section>
	);
}
